<template>
  <div class="profil-container">
    <h3 class="profil-title">Halaman Pengisian Data Vendor</h3>
    <p class="profil-subtitle">Silahkan mengisi data sesuai kolom di bawah</p>

    <!-- 7 -->
    <block-label :label="'7. SERTIFIKASI SISTEM MANAJEMEN'" />
    <plain-label :label="'Berikan keterangan rinci mengenai Sistem Manajemen K3L dan Operasional di perusahaan anda yang sudah mendapatkan sertifikasi atau dinilai/audit oleh pihak ketiga yang terdaftar di badan Akreditasi Nasional/Internasional'
      " />
    <div class="vendor-form-wrapper">
      <input-fill-form :label="'Sistem Manajemen'" :tables="[
        {
          name: 'Sistem Menajemen/Lingkup Audit',
          obj_name: 'lingkup_audit',
          css: 'column20 mr10 all-column',
          input: false,
          type: '',
        },
        {
          name: 'Organisasi Pihak Ketiga (Lembaga Penerbit Sertifikasi)',
          obj_name: 'third_party',
          css: 'column15 mr10 all-column',
          input: false,
          type: '',
        },
        {
          name: 'Masa Berlaku',
          obj_name: 'masa_berlaku',
          css: 'column10 mr10',
          input: false,
          type: '',
        },
        {
          name: 'Tanggal Efektif',
          obj_name: 'tgl_efektif',
          css: 'column10 mr10',
          input: false,
          type: '',
        },
        {
          name: 'Tangga Berakhir',
          obj_name: 'tgl_berakhir',
          css: 'column15 mr10',
          input: false,
          type: '',
        },
        {
          name: 'Sertifikat',
          obj_name: 'sertifikasi',
          css: 'column15 mr10 all-column',
          input: false,
          type: 'file',
        },
      ]" :isRequired="false" :modalName="'modal_add_sistem_manajemen'" :modelName="'addedSistemManajemen'"
        :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'" :operationAdd="'manage_add'"
        :editMutation="'k3lStore/SET_SISTEM_MANAJEMEN'" :disabled="$store.state.k3lStore.is_sipm_approved" />
    </div>
    <plain-label :label="'Lampirkan daftar dokumen kerja (pedoman, prosedur, standar, instruksi kerja, formulir)'
      " />
    <upload-file :modelName="'daftarDokumenKerja'" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'"
      :docId="25" :disabled="$store.state.k3lStore.is_sipm_approved" />
    <plain-label :label="'Lampirkan dokumen kerja (pedoman, prosedur, standar, instruksi kerja, formulir)'
      " />
    <upload-file :modelName="'dokumenKerja'" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'" :docId="26"
      :disabled="$store.state.k3lStore.is_sipm_approved" />
    <plain-label :label="'Lampirkan bukti Pemerikasaan implementasi dokumen kerja (contoh: catatan inspeksi, catatan observasi, catatan hazard report, catatan coaching, dll)'
      " />
    <upload-file :modelName="'pemeriksaanImpelentasiDokumenKerja'" :mutationName="'k3lStore/SET_K3L_FORM'"
      :storeName="'k3lStore'" :docId="27" :disabled="$store.state.k3lStore.is_sipm_approved" />

    <!-- 8 -->
    <block-label :label="'8. KINERJA K3L'" />
    <plain-label :label="`Berikan penjelasan rinci mengenai Kinerja K3L serta statistik untuk kerja keselamatan (angka Frequency Rates 'FR' per 1,000,000 jam kerja). *Jumlah kecelakaan berdampak fatality (FT), Major, Minor Injuries, Medical Treatment Injury (MTI), Restricted Working Injury (RWI), First Aid (FA)  `
      " />
    <input-area :storeName="'k3lStore'" :modelName="'textGroup8'" :mutationName="'k3lStore/SET_K3L_FORM'"
      :disabled="$store.state.k3lStore.is_sipm_approved" />
    <plain-label :label="'Lampirkan informasi statistik kinerja K3L serta statistik untuk kerja keselamatan selama 3 Tahun terakhir '
      " />
    <upload-file :modelName="'statistikKinerjaK3L'" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'"
      :docId="28" :disabled="$store.state.k3lStore.is_sipm_approved" />
    <plain-label :label="'Berikan penjelasan bila perusahaan mengalami kecelakaan berdampak LTI (Lost Time Injury) atau pelanggaran lingkungan akibat dari tindakan Perusahaan, Sub-kontraktor anda atau orang lain yang bertindak atas nama Perusahaan anda selama 3 tahun terakhir'
      " />
    <input-area :storeName="'k3lStore'" :modelName="'textGroup82'" :mutationName="'k3lStore/SET_K3L_FORM'"
      :disabled="$store.state.k3lStore.is_sipm_approved" />
    <plain-label :label="'Lampirkan laporan penyelidikan kecelakaan'" />
    <upload-file :modelName="'penyelidikanKecelakaan'" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'"
      :docId="29" :disabled="$store.state.k3lStore.is_sipm_approved" />

    <div class="profil-btn-wrapper">
      <div @click="goBack()" class="btn-landing">Kembali</div>
      <div @click="goNext()" href="" class="btn-landing">
        Simpan dan Lanjutkan
      </div>
    </div>
  </div>
</template>

<script>
import InputArea from '../../components/forms/input/input-area.vue'
import BlockLabel from '../../components/forms/label/blockLabel.vue'
import PlainLabel from '../../components/forms/label/plainLabel.vue'
import UploadFile from '../../components/forms/input/multiple_upload.vue'
import InputFillForm from '../../components/forms/input-fill-form.vue'
export default {
  components: {
    BlockLabel,
    PlainLabel,
    InputArea,
    UploadFile,
    InputFillForm,
  },
  data() {
    return {}
  },
  methods: {
    goBack() {
      this.$store.commit('k3lStore/SET_ACTIVE_PAGE', { name: 'grup46' })
    },
    goNext() {
      this.$store.commit('k3lStore/SAVE_DRAFT_VENDOR_INPUT', {
        onSuccess: () => {
          this.$store.commit('k3lStore/SET_ACTIVE_PAGE', { name: 'selesai' })
        }
      })
    },
  },
}
</script>
<style scoped>
.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: block;
  overflow: hidden;
  outline: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

.modal-body {
  display: flex;
  flex-direction: column;
}

.modal-input-checkbox {
  margin-right: 20px;
}
</style>
